import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import DarkModeWrapper from './components/DarkModeWrapper';
import TransparencyPortalPage, { TRANSPARENCY_PORTAL_PATH } from './pages/transparencyPortal';

import "primereact/resources/primereact.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";

// portal da transparência é público: não passa pelo login nem pelo fluxo de token do App
const isTransparencyPortal = window.location.pathname.startsWith(TRANSPARENCY_PORTAL_PATH);

// App with browser router
const application = isTransparencyPortal ? (
  <React.StrictMode>
    <TransparencyPortalPage />
  </React.StrictMode>
) : (
  <React.StrictMode>
    <DarkModeWrapper>
      <BrowserRouter>
        <RecoilRoot>
          <App />
        </RecoilRoot>
      </BrowserRouter>
    </DarkModeWrapper>
  </React.StrictMode>
);

// root element
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// render app
root.render(application);
